// buefy removed this component in 5.0.0
// copied here to avoid rewriting existing code
import Menu from './Menu'
import MenuDropdown from './MenuDropdown'
import MenuItem from './MenuItem'
import MenuList from './MenuList'

Vue.component(Menu.name, Menu)
Vue.component(MenuDropdown.name, MenuDropdown)
Vue.component(MenuItem.name, MenuItem)
Vue.component(MenuList.name, MenuList)